<template>
  <div
    class="new-project-container"
    :class="{
      'new-project-container-side-panel': this.$route.name !== 'newCompany',
    }"
  >
    <div class="new-project-header">
      <h2 class="title" v-if="this.$route.name === 'newCompany'">
        Създаване на нова фирма
      </h2>
      <div v-else></div>
      <!-- <h2 class="title" v-if="this.$route.name === 'newProject'">Създаване на нов проект</h2>
      <h2 class="title" v-if="this.$route.name === 'newObject'">Създаване на нов обект</h2>
      <h2 class="title" v-if="this.$route.name === 'newPart'">Създаване на нова част</h2>-->
      <div class="buttons-wrapper">
        <div class="switch-wrapper" v-if="selectedObject !== undefined">
          <label
            class="switch-label"
            :class="{
              'switch-label-active':
                !company.projects[selectedProject].objects[selectedObject]
                  .isActive,
            }"
            @click="
              company.projects[selectedProject].objects[
                selectedObject
              ].isActive = false
            "
            >Неактивен обект</label
          >
          <div class="switch-container">
            <label class="switch">
              <input
                type="checkbox"
                v-model="
                  company.projects[selectedProject].objects[selectedObject]
                    .isActive
                "
                @change="companyChanged()"
              />
              <span class="slider"></span>
            </label>
          </div>
          <label
            class="switch-label"
            :class="{
              'switch-label-active':
                company.projects[selectedProject].objects[selectedObject]
                  .isActive,
            }"
            @click="
              company.projects[selectedProject].objects[
                selectedObject
              ].isActive = true
            "
            >Активен обект</label
          >
        </div>
        <div class="switch-wrapper" v-else>
          <label
            class="switch-label"
            :class="{ 'switch-label-active': !newObject.isActive }"
            @click="newObject.isActive = false"
            >Неактивен обект</label
          >
          <div class="switch-container">
            <label class="switch">
              <input
                type="checkbox"
                v-model="newObject.isActive"
                @change="companyChanged()"
              />
              <span class="slider"></span>
            </label>
          </div>
          <label
            class="switch-label"
            :class="{ 'switch-label-active': newObject.isActive }"
            @click="newObject.isActive = true"
            >Активен обект</label
          >
        </div>
        <button class="btn btn-close desktop" @click="goBack">
          <span class="miv">F</span> Отказ
        </button>
        <button class="btn btn-new desktop" @click="save()">
          <span class="miv">Y</span> Запис
        </button>
      </div>
    </div>
    <!-- NEW REPORT CONTENT -->
    <div
      class="new-wrapper"
      :class="{ 'new-wrapper-inactive': !isObjectActive() }"
    >
      <div
        class="new-content"
        :class="{ 'new-content-side-panel': this.$route.name !== 'newCompany' }"
      >
        <!-- ROW 1 -->
        <div class="new-content-inputs">
          <!-- ИМЕ НА ФИРМА -->
          <div class="new-input-wrapper">
            <label for="newCompany">
              <strong>Фирма*</strong>
            </label>
            <div class="new-input">
              <span class="miv">Z</span>
              <input
                v-if="!company._id"
                type="text"
                placeholder="Име на фирма"
                @focus="getCompanies(), openDropdown(0)"
                @blur="closeDropdown(0)"
                v-model="searchCompanies"
                @change="companyChanged()"
                :disabled="
                  company.companyName.length ||
                  this.$route.name === 'newProject' ||
                  this.$route.name === 'newObject' ||
                  this.$route.name === 'newPart' ||
                  this.$route.name === 'getPart'
                "
              />
              <input
                v-else
                type="text"
                placeholder="Име на фирма"
                @focus="getCompanies(), openDropdown(0)"
                v-model="company.companyName"
                @blur="closeDropdown(0)"
                :disabled="
                  company.companyName.length ||
                  this.$route.name === 'newProject' ||
                  this.$route.name === 'newObject' ||
                  this.$route.name === 'newPart' ||
                  this.$route.name === 'getPart'
                "
              />
              <span
                v-if="
                  company.companyName.length &&
                  !(
                    this.$route.name === 'newProject' ||
                    this.$route.name === 'newObject' ||
                    this.$route.name === 'newPart' ||
                    this.$route.name === 'getPart'
                  )
                "
                class="clear"
                @click="resetSelectedCompany()"
                >F</span
              >
              <template
                v-if="
                  this.$route.name === 'newProject' ||
                  this.$route.name === 'newObject' ||
                  this.$route.name === 'newPart' ||
                  this.$route.name === 'getPart'
                "
              >
                <span
                  class="edit"
                  @click="toggleEdit(company.companyName, 'company')"
                  >c</span
                >
                <span class="disabled">A</span>
              </template>
            </div>
            <div
              class="new-input-dropdown"
              :class="{ 'new-input-dropdown-active': openedDropdown[0] }"
            >
              <ul v-if="companies.length">
                <li
                  v-for="c in filteredCompanies()"
                  :key="c._id"
                  @click="selectCompany(c._id), companyChanged()"
                >
                  {{ c.companyName }}
                </li>
              </ul>
            </div>
          </div>
          <div class="new-input-wrapper">
            <label for>
              <strong>Проект*</strong>
            </label>
            <div class="new-input">
              <span class="miv">Z</span>
              <input
                v-if="selectedProject === undefined"
                type="text"
                placeholder="Име на проект"
                @focus="openDropdown(1)"
                @blur="closeDropdown(1)"
                v-model="searchProjects"
                @change="companyChanged()"
                :disabled="
                  selectedProject !== undefined ||
                  this.$route.name === 'newObject' ||
                  this.$route.name === 'newPart' ||
                  this.$route.name === 'getPart'
                "
              />
              <input
                v-else
                type="text"
                placeholder="Име на проект"
                @focus="openDropdown(1)"
                @blur="closeDropdown(1)"
                v-model="company.projects[selectedProject].projectName"
                :disabled="
                  selectedProject !== undefined ||
                  this.$route.name === 'newObject' ||
                  this.$route.name === 'newPart' ||
                  this.$route.name === 'getPart'
                "
              />
              <span
                v-if="
                  selectedProject !== undefined &&
                  !(
                    this.$route.name === 'newObject' ||
                    this.$route.name === 'newPart' ||
                    this.$route.name === 'getPart'
                  )
                "
                class="clear"
                @click="resetSelectedProject()"
                >F</span
              >
              <template
                v-if="
                  this.$route.name === 'newObject' ||
                  this.$route.name === 'newPart' ||
                  this.$route.name === 'getPart'
                "
              >
                <span
                  class="edit"
                  @click="
                    toggleEdit(
                      company.projects[selectedProject].projectName,
                      'project'
                    )
                  "
                  >c</span
                >
                <span class="disabled">A</span>
              </template>
            </div>
            <div
              class="new-input-dropdown"
              :class="{ 'new-input-dropdown-active': openedDropdown[1] }"
            >
              <ul v-if="company._id">
                <li
                  v-for="(p, index) in filteredProjects()"
                  :key="p._id"
                  @click="selectProject(index), companyChanged()"
                >
                  {{ p.projectName }}
                </li>
              </ul>
            </div>
          </div>
          <!-- ИМЕ НА ОБЕКТ-->
          <div class="new-input-wrapper">
            <label for>
              <strong>Обект*</strong>
            </label>
            <div class="new-input">
              <span class="miv">Z</span>
              <input
                v-if="selectedObject === undefined"
                type="text"
                placeholder="Име на обект"
                @focus="openDropdown(2)"
                @blur="closeDropdown(2)"
                v-model="searchObjects"
                @change="companyChanged()"
                :disabled="
                  selectedObject !== undefined ||
                  this.$route.name === 'newPart' ||
                  this.$route.name === 'getPart'
                "
              />
              <input
                v-else
                type="text"
                placeholder="Име на обект"
                @focus="openDropdown(2)"
                @blur="closeDropdown(2)"
                v-model="
                  company.projects[selectedProject].objects[selectedObject]
                    .objectName
                "
                :disabled="
                  selectedObject !== undefined ||
                  this.$route.name === 'newPart' ||
                  this.$route.name === 'getPart'
                "
              />
              <span
                v-if="
                  (selectedObject !== undefined &&
                    this.$route.name !== 'newPart') ||
                  this.$route.name === 'getPart'
                "
                class="clear"
                @click="resetSelectedObject()"
                >F</span
              >
              <template
                v-if="
                  this.$route.name === 'newPart' ||
                  this.$route.name === 'getPart'
                "
              >
                <span
                  class="edit"
                  @click="
                    toggleEdit(
                      company.projects[selectedProject].objects[selectedObject]
                        .objectName,
                      'object'
                    )
                  "
                  >c</span
                >
                <span class="disabled">A</span>
              </template>
              <!-- <span class="disabled">A</span> -->
            </div>
            <div
              class="new-input-dropdown"
              :class="{ 'new-input-dropdown-active': openedDropdown[2] }"
            >
              <ul v-if="selectedProject !== undefined">
                <li
                  v-for="(o, index) in filteredObjects()"
                  :key="o._id"
                  @click="selectObject(index), companyChanged()"
                >
                  {{ o.objectName }}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- REPORTERS / MATERIALS / ACTIVITIES -->
        <div class="new-content-data-row new-content-data-row-active">
          <!-- REPORTERS -->
          <div class="new-content-data-item">
            <div
              class="new-content-data-item-toggle"
              @click="isAddUsersModalOpened = true"
            >
              <p>Отчетници</p>
              <span class="new-content-data-item-toggle-circle">
                <span class="miv">V</span>
              </span>
            </div>
            <div class="new-content-data-item-content">
              <div class="new-content-data-item-content-lists">
                <template v-if="selectedObject !== undefined">
                  <span
                    v-for="reporter in company.projects[selectedProject]
                      .objects[selectedObject].reporters"
                    :key="`addedReporter-${reporter._id}`"
                    >{{ reporter.name }}</span
                  >
                </template>
                <template v-else>
                  <span
                    v-for="reporter in newObject.reporters"
                    :key="`addedReporter-${reporter._id}`"
                    >{{ reporter.name }}</span
                  >
                </template>
              </div>
            </div>
          </div>
          <!-- PARTS -->
          <div class="new-content-data-item">
            <div
              class="new-content-data-item-toggle"
              @click="isPartsModalOpen = true"
            >
              <p>Части</p>
              <span class="new-content-data-item-toggle-circle">
                <span class="miv">Z</span>
              </span>
            </div>
            <div class="new-content-data-item-content">
              <div class="new-content-data-item-content-lists">
                <template v-if="selectedObject !== undefined">
                  <span
                    v-for="(part, i) in company.projects[selectedProject]
                      .objects[selectedObject].parts"
                    :key="`addedPart-${i}`"
                    >{{ part.partName }}</span
                  >
                </template>
                <template v-else>
                  <!-- TODO: no ids here fix that -->
                  <span
                    v-for="(part, i) in newObject.parts"
                    :key="`addedPart-${i}`"
                    >{{ part.partName }}</span
                  >
                </template>
              </div>
            </div>
          </div>
          <!-- MATERIALS -->
          <!-- <div class="new-content-data-item">
            <div class="new-content-data-item-toggle" @click="isAddMaterialsModalOpened = true">
              <p>Материали</p>
              <span class="new-content-data-item-toggle-circle">
                <span class="miv">T</span>
              </span>
            </div>
            <div v-if="viewLists()" class="new-content-data-item-content">
              <div class="new-content-data-item-content-lists">
                <table v-if="selectedObject !== undefined">
                  <tr
                    v-for="(material, index) in company.projects[selectedProject].objects[selectedObject].materials"
                    :key="`addedMaterial-${index}-${material.materialName}`"
                  >
                    <td
                    class="ma-cell ma-cell-name"
                    :class="{ 'ma-cell-additional' : material.isAdditional }"
                    >
                    <span class="miv" v-if="material.isAdditional">G</span>
                    {{material.materialName}}
                    </td>
                    <td class="ma-cell">{{material.materialUnit}}</td>
                    <td class="ma-cell">{{ (+material.materialPrice) | formatDecimal }} лв</td>
                  </tr>
                </table>
                <table v-else>
                  <tr
                    v-for="(material, index) in newObject.materials"
                    :key="`addedMaterial-${index}-${material.materialName}`"
                  >
                    <td class="ma-cell ma-cell-name">{{material.materialName}}</td>
                    <td class="ma-cell">{{material.materialUnit}}</td>
                    <td class="ma-cell">{{ (+material.materialPrice) | formatDecimal }} лв</td>
                  </tr>
                </table>
              </div>
            </div>
          </div> -->
          <!-- ACTIVITIES -->
          <div class="new-content-data-item">
            <div class="new-content-data-item-toggle">
              <p>Дейности</p>
              <span class="new-content-data-item-toggle-circle">
                <span class="miv">U</span>
              </span>
            </div>
            <div class="new-content-data-item-content">
              <div class="new-content-data-item-content-lists overflow-auto">
                <table>
                  <thead>
                    <tr>
                      <th>№</th>
                      <th>СМР</th>
                      <th>мерна ед-ца</th>
                      <th>Кол-во по договор</th>
                      <th>Ед. Цена на доставка</th>
                      <th>Ед. Цена на монтаж</th>
                      <th>Цена за доставка и монтаж</th>
                      <th>Общо</th>
                      <th
                        v-if="isEarningsManager"
                        title="временно промяната засяга и стари отчети"
                      >
                        Стойност на заработка *
                      </th>
                      <th>Цена на доставка на материала</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(activity, index) in currentObject.activities"
                      :key="`addedActivity-${index}`"
                    >
                      <td
                        class="td-with-input"
                        :class="{
                          'ma-cell-additional': activity.isAdditional,
                        }"
                      >
                        <input
                          type="number"
                          class="td__input"
                          v-model="activity.number"
                        />
                        <span class="miv" v-if="activity.isAdditional">O</span>
                      </td>
                      <td class="td-with-input">
                        <input
                          type="text"
                          class="td__input"
                          v-model="activity.activityName"
                          @change="updateInReports(activity)"
                        />
                      </td>
                      <td class="td-with-input">
                        <input
                          type="text"
                          class="td__input"
                          v-model="activity.activityUnit"
                          @change="updateInReports(activity)"
                        />
                      </td>
                      <td class="td-with-input">
                        <input
                          type="number"
                          class="td__input"
                          v-model="activity.quantity"
                        />
                      </td>
                      <td class="td-with-input">
                        <input
                          type="number"
                          class="td__input"
                          v-model="activity.deliveryPrice"
                        />
                        лв.
                      </td>
                      <td class="td-with-input">
                        <input
                          type="number"
                          class="td__input"
                          v-model="activity.installationPrice"
                        />
                        лв.
                      </td>
                      <td class="td-with-input">
                        <input
                          type="number"
                          class="td__input"
                          v-model="activity.deliveryAndInstallationPrice"
                        />
                        лв.
                      </td>
                      <td class="td-with-input">
                        <input
                          type="number"
                          class="td__input"
                          v-model="activity.activityPrice"
                          @change="updateInReports(activity)"
                        />
                        лв.
                      </td>
                      <td class="td-with-input" v-if="isEarningsManager">
                        <input
                          type="number"
                          class="td__input"
                          v-model="activity.earningsValue"
                          @change="updateInReports(activity)"
                        />
                        лв.
                      </td>
                      <td class="td-with-input">
                        <input
                          type="number"
                          class="td__input"
                          v-model="activity.materialDeliveryPrice"
                        />
                        лв.
                      </td>
                      <td class="delete-row-td">
                        <span
                          class="miv delete-row"
                          @click="removeActivity(index)"
                          >b</span
                        >
                      </td>
                    </tr>
                    <tr class="tr-actions">
                      <td colspan="2">
                        <div class="btns">
                          <button class="btn btn-plus" @click="addActivity">
                            <span>+</span>
                          </button>
                          <button
                            v-if="isEarningsManager"
                            class="btn btn-excel"
                            @click="triggerFileInput()"
                          >
                            <span class="miv">E</span>
                            <template v-if="selectedObject !== undefined">
                              <span
                                v-if="
                                  company.projects[selectedProject].objects[
                                    selectedObject
                                  ].activities.length
                                "
                                >Допълнителен импорт</span
                              >
                              <span v-else>Импорт таблица</span>
                            </template>
                            <template v-else>
                              <span v-if="newObject.activities.length"
                                >Допълнителен импорт</span
                              >
                              <span v-else>Импорт таблица</span>
                            </template>
                          </button>
                          <input
                            ref="uploadActivities"
                            class="input-hide"
                            type="file"
                            @change="handleFile"
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!-- BUTONS MOBILE -->
        <div class="btns mobile">
          <button class="btn btn-close" @click="goBack">
            <span class="miv">F</span> Отказ
          </button>
          <button class="btn btn-new" @click="save()">
            <span class="miv">Y</span> Запис
          </button>
        </div>
        <!-- BUTTON DELETE -->
        <!-- <div class="delete-wrapper">
          <button class="btn btn-delete" v-if="company._id" @click="deleteCompany()">
            <span class="miv">b</span>Изтриване на фирма
          </button>
        </div> -->
      </div>
    </div>

    <!-- ADD REPORTERS MODAL -->
    <transition name="fade">
      <AddUsersModal
        v-if="isAddUsersModalOpened"
        :incomingUsers="getReportersForModal()"
        :usersType="'reporters'"
      />
    </transition>
    <!-- PARTS MODAL -->
    <transition name="fade">
      <PartsModal
        v-if="isPartsModalOpen"
        :parts="getPartsForModal()"
        @close="isPartsModalOpen = false"
        @save="handlePartsSave"
      />
    </transition>
    <!-- ADD MATERIALS MODAL -->
    <transition name="fade">
      <AddMaterialsModal
        v-if="isAddMaterialsModalOpened"
        :incomingMaterials="getMaterialsForModal()"
      />
    </transition>
    <!-- ADD ACTIVITIES MODAL -->
    <transition name="fade">
      <AddActivitiesModal
        v-if="isAddActivitiesModalOpened"
        :incomingActivities="getActivitiesForModal()"
      />
    </transition>
    <!-- ADD ACTIVITIES MODAL -->
    <transition name="fade">
      <EditInputModal
        v-if="isEditInputModalOpened"
        :inputForEdit="inputForEdit"
        :isComingFromCompany="true"
      />
    </transition>
    <transition name="fade">
      <UnsavedChangesModal v-if="isUnsavedChangesModalOpened" />
    </transition>
  </div>
</template>

<script>
import AddUsersModal from "./shared/AddUsersModal";
import PartsModal from "./shared/PartsModal";
import AddMaterialsModal from "./shared/AddMaterialsModal";
import AddActivitiesModal from "./shared/AddActivitiesModal";
import EditInputModal from "./shared/EditInputModal";
import UnsavedChangesModal from "./shared/UnsavedChangesModal";
import * as XLSX from "xlsx";
import log from "./mixins/log.js";
import { mapGetters } from "vuex";
export default {
  components: {
    AddUsersModal: AddUsersModal,
    PartsModal,
    AddMaterialsModal: AddMaterialsModal,
    AddActivitiesModal: AddActivitiesModal,
    UnsavedChangesModal: UnsavedChangesModal,
    EditInputModal: EditInputModal,
  },
  mixins: [log],
  props: ["idToEdit"],
  watch: {
    "$route.path"() {
      this.setRoutes();
    },
  },
  data() {
    return {
      isCompanyChanged: false,
      incomingActivities: [],
      incomingMaterials: [],
      // А boolean for every dropdown in the template
      openedDropdown: [false, false, false, false],
      // Booleans for reporters/materials/activies/ selections modals
      isPartsModalOpen: false,
      isAddUsersModalOpened: false,
      isAddMaterialsModalOpened: false,
      isAddActivitiesModalOpened: false,
      isEditInputModalOpened: false,
      isUnsavedChangesModalOpened: false,
      inputForEdit: {
        value: "",
        where: "",
      },
      isActive: true,
      selectedProject: undefined,
      selectedObject: undefined,
      selectedPart: undefined,
      // SELECTED ARRAYS
      selectedReporters: [],
      selectedMaterials: [],
      selectedActivities: [],
      // SEARCH
      searchCompanies: "",
      searchProjects: "",
      searchObjects: "",
      searchParts: "",
      // The main company object
      companies: [],
      users: [],
      // The specific company object
      company: {
        _id: undefined,
        companyName: "",
        projects: [
          {
            projectName: "",
            objects: [
              {
                isActive: true,
                objectName: "",
                materials: [],
                activities: [],
                reporters: [],
                parts: [],
              },
            ],
          },
        ],
      },
      newProject: {
        projectName: "",
        objects: [],
      },
      newObject: {
        objectName: "",
        isActive: true,
        materials: [],
        activities: [],
        reporters: [],
        parts: [],
      },
      newPart: {
        partName: "",
      },
    };
  },
  computed: {
    ...mapGetters(["isEarningsManager"]),
    currentObject() {
      if (this.selectedObject !== undefined) {
        return this.company.projects[this.selectedProject].objects[
          this.selectedObject
        ];
      } else {
        return this.newObject;
      }
    },
  },
  methods: {
    // DROPDOWNS
    openDropdown(i) {
      this.$set(this.openedDropdown, i, true);
    },
    closeDropdown(i) {
      setTimeout(() => {
        this.$set(this.openedDropdown, i, false);
      }, 100);
    },
    isObjectActive() {
      if (
        this.selectedProject !== undefined &&
        this.selectedObject !== undefined
      ) {
        return this.company.projects[this.selectedProject].objects[
          this.selectedObject
        ].isActive;
      }
      return this.newObject.isActive;
    },
    // SELECTING
    // 1 - SELECT COMPANY BY ID
    selectCompany(id) {
      this.selectedProject = undefined;
      this.selectedObject = undefined;
      this.selectedPart = undefined;
      this.getCompany(id);
    },
    // 2 - SELECT THE INDEX OF A 'PROJECT' INSIDE COMPANY
    selectProject(project) {
      this.selectedObject = undefined;
      this.selectedPart = undefined;
      this.selectedProject = project;
    },
    // 3 - SELECT THE INDEX OF AN 'OBJECT' INSIDE A PROJECT
    selectObject(object) {
      this.selectedPart = undefined;
      this.selectedObject = object;
    },
    // 4 - SELECT THE INDEX OF A 'PART' INSIDE AN OBJECT
    selectPart(part) {
      this.selectedPart = part;
    },
    // RESET SELECTED AND EVERYTHING NESTED INSIDE ON FOCUS
    resetSelectedCompany() {
      this.company = {
        companyName: "",
        projects: [
          {
            _id: "",
            projectName: "",
            objects: [
              {
                _id: "",
                isActive: true,
                objectName: "",
                materials: [],
                activities: [],
                reporters: [],
                parts: [],
              },
            ],
          },
        ],
      };
      this.newProject = {
        projectName: "",
        objects: [],
      };
      this.newObject = {
        objectName: "",
        isActive: true,
        materials: [],
        activities: [],
        reporters: [],
        parts: [],
      };
      this.newPart = {
        partName: "",
      };
      this.searchCompanies = "";
      this.resetSelectedProject();
    },
    resetSelectedProject() {
      this.selectedProject = undefined;
      this.searchProjects = "";
      this.resetSelectedObject();
    },
    resetSelectedObject() {
      this.selectedObject = undefined;
      this.searchObjects = "";
      this.resetSelectedPart();
    },
    resetSelectedPart() {
      this.selectedPart = undefined;
      this.searchParts = "";
    },
    // FILTERED RESULTS WHEN SEARCHING
    filteredCompanies() {
      return this.companies.filter((c) => {
        return c.companyName
          .toLowerCase()
          .includes(this.searchCompanies.toLowerCase());
      });
    },
    filteredProjects() {
      return this.company.projects.filter((p) => {
        return p.projectName
          .toLowerCase()
          .includes(this.searchProjects.toLowerCase());
      });
    },
    filteredObjects() {
      if (this.selectedProject !== undefined) {
        return this.company.projects[this.selectedProject].objects.filter(
          (o) => {
            return o.objectName
              .toLowerCase()
              .includes(this.searchObjects.toLowerCase());
          }
        );
      }
    },
    filteredParts() {
      if (
        this.selectedProject !== undefined &&
        this.selectedObject !== undefined
      ) {
        return this.company.projects[this.selectedProject].objects[
          this.selectedObject
        ].parts.filter((p) => {
          return p.partName
            .toLowerCase()
            .includes(this.searchParts.toLowerCase());
        });
      }
    },
    // RETURN IF REPORTERS/MATERIALS/ACTIVITIES SECTION SHOULD BE VISIBLE
    viewLists() {
      if (this.selectedObject !== undefined) {
        let path =
          this.company.projects[this.selectedProject].objects[
            this.selectedObject
          ];
        return (
          path.reporters.length ||
          path.materials.length ||
          path.activities.length
        );
      } else {
        return (
          this.newObject.reporters.length ||
          this.newObject.materials.length ||
          this.newObject.activities.length
        );
      }
    },
    getReportersForModal() {
      if (this.selectedObject === undefined) {
        return this.newObject.reporters;
      } else {
        return this.company.projects[this.selectedProject].objects[
          this.selectedObject
        ].reporters;
      }
    },
    getPartsForModal() {
      if (this.selectedObject === undefined) {
        return this.newObject.parts;
      } else {
        return this.company.projects[this.selectedProject].objects[
          this.selectedObject
        ].parts;
      }
    },
    getMaterialsForModal() {
      if (this.selectedObject === undefined) {
        return this.newObject.materials;
      } else {
        return this.company.projects[this.selectedProject].objects[
          this.selectedObject
        ].materials;
      }
    },
    getActivitiesForModal() {
      if (this.selectedObject === undefined) {
        return this.newObject.activities;
      } else {
        return this.company.projects[this.selectedProject].objects[
          this.selectedObject
        ].activities;
      }
    },
    // HANDLE THE REPORTERS/MATERIALS/ACTIVITIES RETURNED FROM THE MODALS
    // If we get the 'saveAddUsersModal' event, we assign the workers we receive to the selected/new part
    handleReporters(reporters) {
      if (this.selectedObject === undefined) {
        this.newObject.reporters = reporters;
      } else {
        this.company.projects[this.selectedProject].objects[
          this.selectedObject
        ].reporters = reporters;
      }
      this.closeAddUsersModal();
      this.companyChanged();
    },
    handlePartsSave(parts) {
      if (this.selectedObject === undefined) {
        this.newObject.parts = parts;
      } else {
        this.company.projects[this.selectedProject].objects[
          this.selectedObject
        ].parts = parts;
      }
      this.isPartsModalOpen = false;
      this.companyChanged();
    },
    // If we get the 'saveAddMaterialsModal' event, we assign the workers we receive to the selected/new part
    handleMaterials(materials) {
      if (this.selectedObject === undefined) {
        this.newObject.materials = materials;
      } else {
        this.company.projects[this.selectedProject].objects[
          this.selectedObject
        ].materials = materials;
      }
      this.closeAddMaterialsModal();
      this.companyChanged();
    },
    // If we get the 'saveAddActivitiesModal' event, we assign the workers we receive to the selected/new part
    handleActivities(activities) {
      if (this.selectedObject === undefined) {
        this.newObject.activities = activities;
      } else {
        this.company.projects[this.selectedProject].objects[
          this.selectedObject
        ].activities = activities;
      }
      this.closeAddActivitiesModal();
      this.companyChanged();
    },
    // If we get the 'saveEditInputModal' event, we change the name of the field we need to change
    handleEdit(edited) {
      if (edited.where === "company") {
        this.company.companyName = edited.value;
        this.$snotify.warning(
          "Успешно редактирахте компания. За да запазите промяната кликнете бутон 'Запис'!"
        );
      } else if (edited.where === "project") {
        this.company.projects[this.selectedProject].projectName = edited.value;
        this.$snotify.warning(
          "Успешно редактирахте проект. За да запазите промяната кликнете бутон 'Запис'!"
        );
      } else if (edited.where === "object") {
        this.company.projects[this.selectedProject].objects[
          this.selectedObject
        ].objectName = edited.value;
        this.$snotify.warning(
          "Успешно редактирахте обект. За да запазите промяната кликнете бутон 'Запис'!"
        );
      } else if (edited.where === "part") {
        this.company.projects[this.selectedProject].objects[
          this.selectedObject
        ].parts[this.selectedPart].partName = edited.value;
        this.$snotify.warning(
          "Успешно редактирахте част. За да запазите промяната кликнете бутон 'Запис'!"
        );
      }
      this.closeEditInputModal();
      this.companyChanged();
    },
    // Close the modals when we got the corresponding event
    closeAddUsersModal() {
      this.isAddUsersModalOpened = false;
    },
    closeAddMaterialsModal() {
      this.isAddMaterialsModalOpened = false;
    },
    closeAddActivitiesModal() {
      this.isAddActivitiesModalOpened = false;
    },
    closeEditInputModal() {
      this.isEditInputModalOpened = false;
    },
    toggleEdit(value, where) {
      this.inputForEdit = {
        value: value,
        where: where,
      };
      this.isEditInputModalOpened = true;
    },
    triggerFileInput() {
      this.$refs.uploadActivities.click();
    },
    handleFile(e) {
      let rABS = true; // true: readAsBinaryString ; false: readAsArrayBuffer
      const files = e.target.files;
      const f = files[0];
      if (f.name.match(`.(xls|XLS|xlsx|XLSX)$`)) {
        const reader = new FileReader();
        reader.onload = (e) => {
          let data = e.target.result;
          if (!rABS) data = new Uint8Array(data);
          const workbook = XLSX.read(data, { type: rABS ? "binary" : "array" });

          /* DO SOMETHING WITH workbook HERE */
          const rows = this.workbookToJSON(workbook);
          // SHEET
          for (let row in rows) {
            // const keys = Object.keys(rows[row][0]);
            // for (let i = 0; i < keys.length; i++) {
            //   if (
            //     !(
            //       keys[i].toLowerCase().includes("име") ||
            //       keys[i].toLowerCase().includes("мерна единица") ||
            //       keys[i].toLowerCase().includes("цена")
            //     )
            //   ) {
            //     this.$snotify.error(
            //       "Таблицата трябва да има заглавен ред с Име / Мерна единица / Цена"
            //     );
            //     return;
            //   }
            // }
            // ROW OBJECT
            for (let item in rows[row]) {
              // ROW DATA
              const x = rows[row][item];
              const y = Object.keys(rows[row][item]);

              // rows[row][item][Object.keys(rows[row][item])[0]]

              const a = {
                number: x[y[0]],
                activityName: x[y[1]],
                activityUnit: x[y[2]],
                quantity: x[y[3]],
                deliveryPrice: x[y[4]] ? parseFloat(x[y[4]], 10) : 0,
                installationPrice: x[y[5]] ? parseFloat(x[y[5]], 10) : 0,
                deliveryAndInstallationPrice: x[y[6]]
                  ? parseFloat(x[y[6]], 10)
                  : 0,
                activityPrice: x[y[7]] ? parseFloat(x[y[7]], 10) : 0,
                earningsValue: x[y[8]] ? parseFloat(x[y[8]], 10) : 0,
                materialDeliveryPrice: x[y[9]] ? parseFloat(x[y[9]], 10) : 0,
              };

              this.addActivity(a);
            }
          }
        };
        if (rABS) reader.readAsBinaryString(f);
        else reader.readAsArrayBuffer(f);
      } else {
        this.$snotify.error("Качените файлове трябва да бъдат .xls или .xlsx");
      }
    },
    workbookToJSON(workbook) {
      var result = {};
      workbook.SheetNames.forEach((sheetName) => {
        var roa = XLSX.utils.sheet_to_row_object_array(
          workbook.Sheets[sheetName]
        );
        if (roa.length > 0) {
          result[sheetName] = roa;
        }
      });
      return result;
    },
    addActivity(a) {
      const activity = a || {};

      this.currentObject.activities.push(activity);
    },
    removeActivity(i) {
      this.currentObject.activities.splice(i, 1);
    },
    updateInReports(a) {
      if (!a.updateInReports) this.$set(a, "updateInReports", true);
    },
    // REQUESTS
    // GET ALL COMPANIES REQUEST
    getCompanies() {
      let requestUrl = `${process.env.VUE_APP_BASE_URI}/company/names`;
      this.$http
        .get(requestUrl)
        .then((response) => {
          this.companies = response.data;
          // console.log(JSON.stringify(this.companies));
        })
        .catch((error) => console.log(error));
    },
    // GET SPECIFIC COMPANY BY ID REQUEST
    getCompany(companyId) {
      this.resetSelectedProject();
      let url = `${process.env.VUE_APP_BASE_URI}/company/${companyId}`;
      this.$http
        .get(url)
        .then((response) => {
          this.company = response.data;
        })
        .catch((error) => console.log(error));
    },
    // GET and SET Selected Company and Project
    getProject(companyId, projectId) {
      this.resetSelectedObject();
      let url = `${process.env.VUE_APP_BASE_URI}/company/${companyId}`;
      this.$http
        .get(url)
        .then((response) => {
          this.company = response.data;

          for (let project in this.company.projects) {
            if (this.company.projects[project]._id == projectId) {
              // SET Project
              this.selectedProject = project;
            }
          }
        })
        .catch((error) => console.log(error));
    },
    // GET and SET Selected Company, Project and Object
    getObject(companyId, projectId, objectId) {
      this.resetSelectedPart();
      let url = `${process.env.VUE_APP_BASE_URI}/company/${companyId}`;
      this.$http
        .get(url)
        .then((response) => {
          this.company = response.data;

          for (let project in this.company.projects) {
            if (this.company.projects[project]._id == projectId) {
              // SET Project
              this.selectedProject = project;
              for (let object in this.company.projects[project].objects) {
                if (
                  this.company.projects[this.selectedProject].objects[object]
                    ._id == objectId
                ) {
                  // SET Object
                  this.selectedObject = object;

                  this.company.projects[this.selectedProject].objects[
                    this.selectedObject
                  ].parts.sort((a, b) => (a.partName > b.partName ? 1 : -1));
                }
              }
            }
          }
        })
        .catch((error) => console.log(error));
    },
    // GET and SET Selected Company, Project, Object and Part
    getPart(companyId, projectId, objectId, partId) {
      let url = `${process.env.VUE_APP_BASE_URI}/company/${companyId}`;
      this.$http
        .get(url)
        .then((response) => {
          this.company = response.data;

          for (let project in this.company.projects) {
            if (this.company.projects[project]._id == projectId) {
              // SET Project
              this.selectedProject = project;
              for (let object in this.company.projects[project].objects) {
                if (
                  this.company.projects[this.selectedProject].objects[object]
                    ._id == objectId
                ) {
                  // SET Object
                  this.selectedObject = object;
                  for (let part in this.company.projects[project].objects[
                    object
                  ].parts) {
                    if (
                      this.company.projects[this.selectedProject].objects[
                        this.selectedObject
                      ].parts[part]._id == partId
                    ) {
                      // SET Object
                      this.selectedPart = part;
                    }
                  }
                }
              }
            }
          }
        })
        .catch((error) => console.log(error));
    },
    companyChanged() {
      if (!this.isCompanyChanged) {
        this.isCompanyChanged = true;
      }
    },
    save() {
      let dublicated = false;

      //companies
      this.companies.filter((n) => {
        if (
          n.companyName.toLowerCase() === this.searchCompanies.toLowerCase() &&
          !this.company.companyName
        ) {
          this.$snotify.error("Има вече фирма с такова име.");
          dublicated = true;
        }
      });
      //companies

      if (this.company._id && this.company.projects) {
        //projects and objects
        this.company.projects.filter((n) => {
          if (
            n.projectName.toLowerCase() === this.searchProjects.toLowerCase() &&
            this.selectedProject === undefined
          ) {
            this.$snotify.error("Има вече проект с такова име.");
            dublicated = true;
          }

          for (let o of n.objects) {
            if (
              o.objectName.toLowerCase() === this.searchObjects.toLowerCase() &&
              this.selectedObject === undefined
            ) {
              this.$snotify.error("Има вече обект с такова име.");
              dublicated = true;
            }
          }
        });
        //projects and objects
      }

      // IF THERE IS NO SELECTED COMPANY WE'RE MAKING A BRAND NEW ONE
      if (!dublicated) {
        if (!this.company._id && this.fieldsValidation()) {
          if (confirm("Сигурни ли сте, че искате да създадете нова фирма?")) {
            this.postCompany();
          }
          // IN ALL OTHER CASES WE'RE UPDATING AN EXISTING ONE
        } else if (this.company._id && this.fieldsValidationEdit()) {
          this.updateCompany();
        }
      }
    },
    checkForUnsavedData(next) {
      this.isUnsavedChangesModalOpened = true;
      this.$once("closeUnsavedChangesModal", (answer) => {
        // confirm
        if (answer) {
          next(false);
          this.save();
        }
        // decline
        else {
          next();
        }
        this.isUnsavedChangesModalOpened = false;
        this.isCompanyChanged = false;
      });
    },
    // POST COMPANY REQUEST
    postCompany() {
      this.company.companyName = this.searchCompanies;
      this.company.projects[0].projectName = this.searchProjects;
      this.company.projects[0].objects[0].objectName = this.searchObjects;
      this.company.projects[0].objects[0].materials = this.newObject.materials;
      this.company.projects[0].objects[0].activities =
        this.newObject.activities;
      this.company.projects[0].objects[0].reporters = this.newObject.reporters;
      this.company.projects[0].objects[0].isActive = this.newObject.isActive;
      if (this.searchParts.length) {
        this.company.projects[0].objects[0].parts.push({
          partName: this.searchParts,
        });
      }
      let url = `${process.env.VUE_APP_BASE_URI}/company`;
      this.$http
        .post(url, this.company)
        .then(() => {
          this.$snotify.success("Успешно добавихте нова фирма!");
          this.isCompanyChanged = false;
          this.newLog("newCompany", this.company.companyName);
          this.goBack();
        })
        .catch((error) => {
          console.log(error);
          this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
        });
    },
    // UPDATE COMPANY REQUEST
    updateCompany() {
      let updatedActivities = 0;
      // NEW PART
      if (this.selectedPart === undefined) {
        // * PART IS OPTIONAL
        if (this.searchParts.length) {
          this.newPart.partName = this.searchParts;
        }
        // NEW OBJECT
        if (this.selectedObject === undefined) {
          this.newObject.objectName = this.searchObjects;
          // * PART IS OPTIONAL
          if (this.searchParts.length) {
            this.newObject.parts.push(this.newPart);
          }
          // NEW PROJECT
          if (this.selectedProject === undefined) {
            this.newProject.projectName = this.searchProjects;
            this.newProject.objects.push(this.newObject);
            this.company.projects.push(this.newProject);
          }
          // IF THERE IS SELECTED PROJECT PUSH THE NEW OBJECT TO IT
          else {
            this.company.projects[this.selectedProject].objects.push(
              this.newObject
            );
          }
        }
        // IF THERE IS SELECTED OBJECT PUSH THE NEW PART TO IT
        else {
          // * PART IS OPTIONAL
          if (this.searchParts.length) {
            this.company.projects[this.selectedProject].objects[
              this.selectedObject
            ].parts.push({ partName: this.searchParts });
          }

          // count updated activities
          for (let a of this.company.projects[this.selectedProject].objects[
            this.selectedObject
          ].activities) {
            if (a.updateInReports && a._id) {
              updatedActivities += 1;
            }
          }
        }
      }

      // let requestObject = {
      //   _id: this.company._id,
      //   companyName: this.company.companyName,
      //   projects: []
      // };

      // if (this.selectedProject !== undefined) {
      //   requestObject.projects.push(
      //     this.company.projects[this.selectedProject]
      //   );
      // } else {
      //   requestObject.projects.push({
      //     projectName: this.searchProjects,
      //     objects: []
      //   });
      // }

      // if (this.selectedProject !== undefined && this.selectedObject !== undefined) {
      //   requestObject.projects[0].objects.push(
      //     this.company.projects[this.selectedProject].objects[this.selectedObject]
      //   );
      // } else {
      //   requestObject.projects[0].objects.push({
      //     objectName: this.searchObjects,
      //     parts: [],
      //     materials: this.newObject.materials,
      //     activities: this.newObject.activities,
      //     reporters: this.newObject.reporters,
      //     isActive: this.newObject.isActive
      //   });
      // }

      // if (this.selectedProject !== undefined && this.selectedObject !== undefined && this.selectedPart !== undefined) {
      //   requestObject.projects[0].objects[0].parts.push(
      //     this.company.projects[this.selectedProject].objects[this.selectedObject].parts
      //   );
      // } else {
      //   requestObject.projects[0].objects[0].parts.push({
      //     partName: this.searchParts,
      //   });
      // }

      // MAKE THE REQUEST
      let url = `${process.env.VUE_APP_BASE_URI}/company/${this.company._id}`;

      this.$http
        .put(url, this.company)
        .then(() => {
          let msg = "Промените са записани успешно!";

          if (updatedActivities) {
            if (updatedActivities === 1) {
              msg += ` 1 дейност ще бъде обновена в отчетите.`;
            } else {
              msg += ` ${updatedActivities} дейности ще бъдат обновени в отчетите.`;
            }
          }

          this.$snotify.success(msg);

          this.isCompanyChanged = false;
          this.newLog("editCompany", this.company.companyName);
          this.goBack();
        })
        .catch((error) => {
          console.log(error);
          this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
        });
    },
    deleteCompany() {
      if (this.company._id) {
        if (confirm("Сигурни ли сте, че искате да изтриете тази фирма?")) {
          this.$router.push("/companies");
          this.deleteCompanyRequest();
        }
      }
    },
    deleteCompanyRequest() {
      let url = `${process.env.VUE_APP_BASE_URI}/company/${this.company._id}`;
      this.$http
        .delete(url)
        .then(this.$snotify.success("Фирмата е изтрита успешно."))
        .catch((error) => {
          if (error.response.status == 404) {
            this.$snotify.error("Не е намерена фирма.");
          } else {
            this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
          }
        });
    },
    // CANCEL
    goBack() {
      if (this.$route.query.from) {
        this.$router.push(this.$route.query.from);
      } else {
        this.$router.push("/companies");
      }
    },
    fieldsValidation() {
      if (!this.searchCompanies) {
        this.$snotify.error("Моля въдедете име на фирма.");
        return false;
      }
      if (!this.searchProjects) {
        this.$snotify.error("Моля въведете проект.");
        return false;
      }
      if (!this.searchObjects) {
        this.$snotify.error("Моля въведете обект");
        return false;
      }
      if (this.searchCompanies && this.searchProjects && this.searchObjects) {
        return true;
      }
    },
    fieldsValidationEdit() {
      let project = this.company.projects[this.selectedProject];
      let object = project ? project.objects[this.selectedObject] : false;

      if (!this.company.companyName && !this.searchCompanies) {
        this.$snotify.error("Моля въдедете име на фирма.");
        return false;
      }
      if (!project && !this.searchProjects) {
        this.$snotify.error("Моля въведете проект.");
        return false;
      }
      if (!object && !this.searchObjects) {
        this.$snotify.error("Моля въведете обект");
        return false;
      }

      return true;
    },
    setRoutes() {
      if (this.$route.name === "newProject") {
        this.getCompany(this.$route.params.companyId);
      } else if (this.$route.name === "newObject") {
        this.getProject(
          this.$route.params.companyId,
          this.$route.params.projectId
        );
      } else if (this.$route.name === "newPart") {
        this.getObject(
          this.$route.params.companyId,
          this.$route.params.projectId,
          this.$route.params.objectId
        );
      } else if (this.$route.name === "getPart") {
        this.getPart(
          this.$route.params.companyId,
          this.$route.params.projectId,
          this.$route.params.objectId,
          this.$route.params.partId
        );
      }
    },
  },
  mounted() {
    this.setRoutes();
    this.getCompanies();
    // SAVE HANDLERS
    this.$on("saveAddUsersModal", this.handleReporters);
    this.$on("saveAddMaterialsModal", this.handleMaterials);
    this.$on("saveAddActivitiesModal", this.handleActivities);
    this.$on("saveEditInputModal", this.handleEdit);
    // CLOSE HANDLERS
    this.$on("closeAddUsersModal", this.closeAddUsersModal);
    this.$on("closeAddMaterialsModal", this.closeAddMaterialsModal);
    this.$on("closeAddActivitiesModal", this.closeAddActivitiesModal);
    this.$on("closeEditInputModal", this.closeEditInputModal);
  },
  beforeRouteLeave(to, from, next) {
    if (this.isCompanyChanged) {
      this.checkForUnsavedData(next);
    } else {
      next();
    }
  },
  destroyed() {
    // STOP LISTENING FOR THE EVENTS
    this.$off("saveAddUsersModal");
    this.$off("saveAddMaterialsModal");
    this.$off("saveAddActivitiesModal");
    this.$off("saveEditInputModal");
    this.$off("closeAddUsersModal");
    this.$off("closeAddMaterialsModal");
    this.$off("closeAddActivitiesModal");
    this.$off("closeEditInputModal");
  },
};
</script>

<style scoped>
.title {
  color: #373737;
  font-size: 20px;
}
.new-content {
  width: 100%;
}
.new-content-side-panel {
  width: 100%;
  padding: 10px;
  /* height: 100vh; */
  /* overflow: auto; */
}
.new-project-container {
  align-items: center;
  margin-left: 40px;
  margin-right: 40px;
  margin-bottom: 27px;
}
.new-project-container-side-panel {
  margin-left: 24px;
  width: 70%;
}
.new-project-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
  padding-top: 11px;
}
.new-project-wrapper {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  width: 100%;
}
.buttons-wrapper {
  display: flex;
  flex-direction: row;
}
.switch-wrapper {
  align-items: center;
  display: flex;
}
.switch {
  margin: 0 10px;
}
.switch-label {
  cursor: pointer;
  font-weight: 700;
  opacity: 0.4;
}
.switch-label-active {
  opacity: 1;
}
.delete-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  width: 100%;
}
thead th:first-child {
  padding-left: 20px;
}
thead th:nth-child(2) {
  text-align: left;
  padding-left: 10px;
}
.td-with-input {
  font-size: 11px;
  height: initial;
  padding: 2px 0;
  white-space: nowrap;
}
.td-with-input:nth-child(1) {
  padding-left: 20px;
  position: relative;
}
.td-with-input:not(:nth-child(1)) {
  padding-left: 10px;
}
.td-with-input:not(:nth-child(2)) {
  width: 1%;
}
.td-with-input:nth-child(2) .td__input {
  width: 100%;
}
.td-with-input > .miv {
  color: #d88e0f;
  /* font-weight: 700; */
  left: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.td__input {
  border-radius: 4px;
  border: 1px solid rgba(112, 112, 112, 0.5);
  font-size: 11px;
  height: 16px;
  margin: 0;
  padding: 0 5px;
  width: 60px;
}
.tr-actions td {
  padding-top: 5px;
}
.tr-actions td:first-child {
  padding-left: 20px;
}
.tr-actions .btn-plus {
  margin: 0;
}
.tr-actions .btn-excel {
  padding-left: 10px;
  padding-right: 10px;
  width: initial;
  white-space: nowrap;
}
.delete-row-td {
  margin: 0;
  padding: 0;
  width: 1%;
}
.delete-row {
  color: #ff0000;
  cursor: pointer;
  opacity: 0;
  vertical-align: middle;
  margin-left: 10px;
  transition: all 0.3s;
}
tr:hover .delete-row {
  opacity: 0.2;
}
tr:hover .delete-row:hover {
  opacity: 0.8;
}
/* .desktop {
  display: flex;
} */
.overflow-auto {
  overflow: auto;
}
.mobile {
  display: none;
}
/* Responsive */
@media screen and (max-width: 1000px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: flex;
  }
  .projects-wrapper {
    justify-content: center;
  }
  .new-project-container-side-panel {
    width: 100%;
  }
  .new-project-container {
    width: 92%;
    margin: 0 15px;
    margin-bottom: 27px;
  }
  .new-content-inputs {
    display: flex;
    flex-direction: column;
  }
  .new-input-wrapper {
    margin-right: 0px;
    width: 100%;
  }
  .new-project-header {
    justify-content: center;
  }
  .new-content-data-item-toggle.mobile {
    text-align: center;
    flex-direction: column;
    height: auto;
    padding-bottom: 0.6em;
  }
  .new-content-data-item-toggle.mobile p {
    margin-top: 0.6em;
    margin-bottom: 0.6em;
  }
  .btns.mobile {
    display: flex;
    justify-content: center;
    margin: 10px 0;
  }
  .delete-wrapper {
    justify-content: center;
  }
  .btn.btn-delete {
    width: 330px;
  }
  .new-content {
    width: 100%;
  }
  .new-content-data-item-content-lists > span {
    width: 30%;
  }
  .new-content-data-item-content-lists {
    overflow: auto;
  }
  .new-content-data-item-content .ma-cell {
    padding: 0px;
  }
}
@media screen and (max-width: 340px) {
  .new-content-data-item {
    margin-right: 4px;
  }
}
</style>
